import { ComponentPortal, DomPortalOutlet } from "@angular/cdk/portal";
import { isPlatformBrowser } from "@angular/common";
import { ApplicationRef, ComponentFactoryResolver, Inject, Injectable, Injector, PLATFORM_ID } from "@angular/core";
import { SignedContractComponent } from "../components/signed-contract/signed-contract.component";
import { Constant } from "../constant";
import { AuthService } from "./auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class WeetrustService {

    constructor(
        private readonly componentFactoryResolver: ComponentFactoryResolver,
        private readonly applicationRef: ApplicationRef,
        private readonly injector: Injector,
        private readonly authService: AuthService,
        private readonly constant: Constant,
        @Inject(PLATFORM_ID) private platformId: Object,
    ) {}

    public contractSigning(signingUrl: string): void {
        //if (isPlatformBrowser(this.platformId)) {
            const width = window.screen.width;
            const height = window.screen.height;

            window.open(signingUrl, '_blank', `width=${width},height=${height}`);
        //}
    }

    public contractLeasing(signingUrl: string): void {
        //if (isPlatformBrowser(this.platformId)) {
            const width = window.screen.width;
            const height = window.screen.height;

            window.open(signingUrl, '_blank', `width=${width},height=${height}`);
        //}
    }
}